module.exports = __webpack_public_path__ + "static/haveOther.d13dc0a0.png";